import { useEffect, useState } from 'react';
import { API_BASE_URL, authFetch } from '@/services/api';

// DB asset uuid -> SCADA mock station id (src/scada/mock/stations.ts).
const ASSET_TO_MOCK: Record<string, string> = {
  '4b108b61-fe83-47dc-81b8-04db6d409aab': 'bolgrad',
  '12a78662-a28d-40d5-9eb7-e83ebb158b41': 'tabaki',
  '38e171c0-d78f-4ff5-92d2-67f33e7b1f26': 'prometheus',
  'cf6ed1b6-a32a-4b79-b392-40f85e084376': 'nickelios',
  'b004264d-618d-40ed-b8e7-7718947e1213': 'nikopol',
  'ef2f4575-a1bd-408b-b867-e2d9618bfc18': 'luchky',
};

// Set of SCADA mock station ids the logged-in account may see (its portfolio),
// or null while loading / on error -> caller falls back to the full fleet.
export function useAllowedStationIds(): Set<string> | null {
  const [ids, setIds] = useState<Set<string> | null>(null);
  useEffect(() => {
    let alive = true;
    authFetch(`${API_BASE_URL}/owner/stations`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((d) => {
        if (!alive) return;
        const set = new Set<string>();
        for (const s of d.stations || []) {
          const m = ASSET_TO_MOCK[s.id];
          if (m) set.add(m);
        }
        setIds(set);
      })
      .catch(() => { if (alive) setIds(null); });
    return () => { alive = false; };
  }, []);
  return ids;
}
